import { FC } from 'react';
import clsx from 'clsx';
import { kebabCase } from 'lodash-es';
import { Icon } from '@namespace/icons2';
import { eventHandlerWrapper } from '../../../../utils/eventHandlerWrapper';
import { MobileSelectProps } from '../../types';

import styles from './index.module.css';

export const MobileSelect: FC<MobileSelectProps> = ({
  options,
  onChange,
  onBlur = () => {},
  value,
  style,
  disabled,
  placeholder,
  size = 'xs',
  arrowSize,
  iconDropDownName = 'icons/general/nav/dropdown_down',
  intent,
  className,
  dataRole,
  mobileSelectStyle = '',
  intentType,
  showDropdownIconWhenOnlyOneOption,
  disableDropdownWhenOnlyOneOption,
  isCustomLanguageSelect,
  bottomElement = null,
  contentAfter
}) => {
  const isSingleOption = options.length === 1;
  const shouldDisable =
    disabled || (disableDropdownWhenOnlyOneOption && isSingleOption);
  const showIcon =
    (showDropdownIconWhenOnlyOneOption && isSingleOption) || options.length > 1;

  return (
    <div
      style={style}
      data-role={dataRole}
      className={clsx([
        styles.mobileWrapper,
        styles[size],
        intent && styles[intent],
        shouldDisable && styles.disabled,
        placeholder && !value && styles.placeholder,
        className
      ])}
    >
      <div className={styles.selectWrapper}>
        {!isCustomLanguageSelect &&
          options.find((item) => item.value === value)?.iconElement}
        <select
          value={value || ''}
          className={clsx([
            styles.select,
            intentType ? styles[intentType] : undefined,
            mobileSelectStyle
          ])}
          onChange={eventHandlerWrapper(onChange, options)}
          onBlur={eventHandlerWrapper(onBlur, options)}
          disabled={disabled}
        >
          {placeholder && !value && (
            <option value="" disabled={true}>
              {placeholder}
            </option>
          )}
          {options.map((option) => (
            <option
              value={option.value}
              data-role={`option-${kebabCase(option.value?.toString())}`}
              key={`${option.value}-${option.title}`}
            >
              {option.title}
            </option>
          ))}
        </select>
        {showIcon && (
          <Icon
            name={iconDropDownName}
            className={clsx(
              styles.icon,
              intentType ? styles[intentType] : undefined,
              disabled && styles.disabled,
              contentAfter && styles.extraSpace
            )}
            size={arrowSize || size}
          />
        )}
        {bottomElement}
      </div>
      {contentAfter}
    </div>
  );
};
